import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

import EntityMenuItem from '../../../EntityMenuItem';
import { getTemplateUrl } from '../helpers/utils';

const FormTemplatesEntityMenuItem = ({ entity: template, ...rest }) => {
  const projectId = useCurrentProjectId();

  const label = <OverflowTooltip>{template.name}</OverflowTooltip>;
  return (
    <EntityMenuItem
      link={getTemplateUrl(projectId, template.uid, template.folder_uid)}
      label={label}
      {...rest}
    />
  );
};

export default FormTemplatesEntityMenuItem;
